// extracted by mini-css-extract-plugin
export default {"mainDiv":"PageLoading_mainDiv__sfIPt"};